import { AppDispatch } from "@Reducers/index";
import { getBackendUrl } from "@Utils";
import axiosWrapper from "../services/axiosWrapper";
import { setWorkflowData, setReviewData } from "../reducers/Workflows";
import type { GetReviewFlowDataRequest, GetReviewFlowDataResponse } from "@ServerTypes/workflows/workflows.schema.js";
import type { GetReviewDataRequest, GetReviewDataResponse } from "@ServerTypes/reviews/reviews.schema.js";

export function fetchWorkflowData({ reviewFlowId }: { reviewFlowId: string }) {
  return async (dispatch: AppDispatch) => {
    const data: GetReviewFlowDataRequest = { id: reviewFlowId };
    const response = await axiosWrapper.post<GetReviewFlowDataResponse>(
      `${getBackendUrl()}/reviewflows/getReviewFlowData`,
      data,
    );

    if (response.data.status && response.data.result) {
      dispatch(setWorkflowData(response.data.result));
    }
  };
}

export function fetchReviewData({ reviewId }: { reviewId: string }) {
  return async (dispatch: AppDispatch) => {
    const data: GetReviewDataRequest = { _id: reviewId };

    const response = await axiosWrapper.post<GetReviewDataResponse>(`${getBackendUrl()}/reviews/getReviewData`, data);

    if (response.data.status && response.data.result) {
      dispatch(setReviewData(response.data.result));
    }
  };
}
